import { component } from 'picoapp';

export default component(async (node) => {
  const content = document.querySelector('[data-content]');

  if (content) {
    const list = document.createElement('ul');
    const headings = content.querySelectorAll('h1, h2, h3, h4, h5, h6');

    headings.forEach((heading) => {
      const li = document.createElement('li');
      const a = document.createElement('a');

      // eslint-disable-next-line no-script-url
      a.href = 'javascript:';
      a.textContent = heading.textContent;

      li.appendChild(a);
      list.appendChild(li);

      a.addEventListener('click', (event) => {
        event.preventDefault();

        heading.scrollIntoView({ behavior: 'smooth' });
      });
    });

    node.appendChild(list);
  }
});
